import { type MarkSpec, type DOMOutputSpec } from "prosemirror-model";

export const bold: MarkSpec = {
  parseDOM: [
    { tag: "strong" },
    {
      tag: "b",
      getAttrs: (node: HTMLElement) =>
        node.style.fontWeight !== "normal" && null,
    },
    { style: "font-weight=400", clearMark: (m) => m.type.name === "strong" },
    {
      style: "font-weight",
      getAttrs: (value: string) =>
        /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
    },
  ],
  toDOM() {
    return ["strong", 0] as DOMOutputSpec;
  },
};

export const italic: MarkSpec = {
  parseDOM: [
    { tag: "i" },
    { tag: "em" },
    { style: "font-style=italic" },
    { style: "font-style=normal", clearMark: (m) => m.type.name === "em" },
  ],
  toDOM() {
    return ["em", 0] as DOMOutputSpec;
  },
};

export const link: MarkSpec = {
  attrs: {
    href: { validate: "string" },
    title: { default: null, validate: "string|null" },
    target: { default: "_blank" },
  },
  inclusive: false,
  parseDOM: [
    {
      tag: "a[href]",
      getAttrs(dom: HTMLElement) {
        return {
          href: dom.getAttribute("href"),
          title: dom.getAttribute("title"),
          target: dom.getAttribute("target"),
        };
      },
    },
  ],
  toDOM(node) {
    const { href, title, target } = node.attrs;
    return ["a", { href, title, target }, 0];
  },
};

export const strikethrough: MarkSpec = {
  parseDOM: [
    { tag: "strike" },
    { style: "text-decoration=line-through" },
    { style: "text-decoration-line=line-through" },
  ],
  toDOM() {
    return [
      "span",
      {
        style: "text-decoration-line:line-through",
      },
      0,
    ] as DOMOutputSpec;
  },
};

// Not used by the editor but is accounted for in the keymap
export const code: MarkSpec = {
  code: true,
  parseDOM: [{ tag: "code" }],
  toDOM() {
    return ["code", 0] as DOMOutputSpec;
  },
};

export const marks = {
  bold,
  code,
  italic,
  link,
  strikethrough,
};
